import { createFeatureSelector } from '@ngrx/store';

import * as AppSettingsReducer from './app-settings.reducer';

export const selectAppSettingsState = createFeatureSelector<AppSettingsReducer.AppSettingsState>('appSettings');
